export enum EUserRoles {
  /* ALS */
  ALS_SPRAVCA = 'ALS_SPRAVCA',
  ALS_PREZER_SLA = 'ALS_PREZER_SLA',
  /* NTF */
  NTF_SPRAVCA = 'NTF_SPRAVCA',

  HOD_SCHVAL = 'HOD_SCHVAL',

  /* HP */
  HP_SZA_AUDITOR = 'HP_SZA_AUDITOR',
  HP_SZA_MAJITEL_AUDIT = 'HP_SZA_MAJITEL_AUDIT',
  HP_SZA_SPRAV_AUDIT = 'HP_SZA_SPRAV_AUDIT',
  HP_SZA_UCASTNIK_AUDIT = 'HP_SZA_UCASTNIK_AUDIT',
  HP_SZA_VED_AUDIT = 'HP_SZA_VED_AUDIT',
  HP_SZA_ZMOCNEN_AUDIT = 'HP_SZA_ZMOCNEN_AUDIT',
  HP_NPO_SPRAV_NPO = 'HP_NPO_SPRAV_NPO',
  HP_NPO_MAJ_PROC = 'HP_NPO_MAJ_PROC',

  /* KP - Navrh produktu */
  KP_NAVRH_PROD_PRIP = 'KP_NAVRH_PROD_PRIP',
  KP_NAVRH_PROD_SCHV = 'KP_NAVRH_PROD_SCHV',
  KP_NAVRH_PROD_ZAD = 'KP_NAVRH_PROD_ZAD',

  /* KP - Katalogy */
  KATC_PRZ_SPRAVCA = 'KATC_PRZ_SPRAVCA',
  KATC_PRZ_GESTOR = 'KATC_PRZ_GESTOR',
  KATC_UK_GESTOR = 'KATC_UK_GESTOR',
  KATC_UK_SPRAVCA = 'KATC_UK_SPRAVCA',
  KATC_PROD_SPRAVCA = 'KATC_PROD_SPRAVCA',
  KATC_PROC_SPRAVCA = 'KATC_PROC_SPRAVCA',
  KATC_PK_SPRAVCA = 'KATC_PK_SPRAVCA',
  KATC_IK_SPRAVCA = 'KATC_IK_SPRAVCA',
  KATC_SPR_SPRAVCA = 'KATC_SPR_SPRAVCA',
  KATC_CIS_GESTOR = 'KATC_CIS_GESTOR',
  KATC_CIS_SPRAVCA = 'KATC_CIS_SPRAVCA',
  KATC_DIM_SPRAVCA = 'KATC_DIM_SPRAVCA',
  KATC_SZ_GESTOR = 'KATC_SZ_GESTOR',
  KATC_SZ_SPRAVCA = 'KATC_SZ_SPRAVCA',
  KATC_AZU_EZU_COORDINATOR = 'KATC_AZU_EZU_COORDINATOR',
  KATC_DIS_SPRAVCA = 'KATC_DIS_SPRAVCA',
  KATC_ZIADATEL_ZMENA = 'KATC_ZIADATEL_ZMENA',
  KATC_INT_CIS_SPRAVCA = 'KATC_INT_CIS_SPRAVCA',

  /* KP */
  KP_KOORDINATOR_SKUPINA = 'KP_KOORDINATOR_SKUPINA',
  KP_PREZER_POZ = 'KP_PREZER_POZ',
  KP_PRIJIM_POZ = 'KP_PRIJIM_POZ',
  KP_ZAD_POZ = 'KP_ZAD_POZ',

  /* TZAR */
  TZAR_SPRAVCA_SAB = 'TZAR_SPRAVCA_SAB',

  /* UAA */
  UAA_SPRAVCA = 'UAA_SPRAVCA',
  UAA_MIB = 'UAA_MIB',

  /* DM */
  DB_AZU_EZU_INTEGRATION_FILE_UPLOAD = 'DB_AZU_EZU_INTEGRATION_FILE_UPLOAD',
  DM_DATA_SOURCE_SYSTEM_ADMINISTRATOR = 'DM_DATA_SOURCE_SYSTEM_ADMINISTRATOR',
  DM_DATA_SOURCE_ADMIN = 'DM_DATA_SOURCE_ADMIN',
  DM_JPBD_ADMINISTRATOR = 'DM_JPBD_ADMINISTRATOR',
  DM_JPBD_PRISTUP_KU_DATAM = 'DM_JPBD_PRISTUP_KU_DATAM',
  DM_SV_ADMIN = 'DM_SV_ADMIN',
  DM_JZBD_EDZ_USER = 'DM_JZBD_EDZ_USER',
  DM_JZBD_SV_USER = 'DM_JZBD_SV_USER',
  DM_JZBD_AZUEZU_USER = 'DM_JZBD_AZUEZU_USER',
  DM_JPBD_USER = 'DM_JPBD_USER',
  DM_DP_USER = 'DM_DP_USER',

  /* DMS */
  DMS_SPRAVCA = 'DMS_SPRAVCA',

  /* Global */
  SERVICE_USER = 'SERVICE_USER',
  JISSU_USER = 'JISSU_USER',
}
